module.exports = __webpack_public_path__ + "static/img/2.22a25efc.png";